/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ItemModel { 
    itemNumber?: string | null;
    itemDescription?: string | null;
    itemClass?: string | null;
    uofm?: string | null;
    inventoryCount?: string | null;
    inventoryQuantity?: number;
    readonly inventoryQuantityDisplay?: string | null;
    inventoryInTransitQuantity?: number;
    readonly inventoryInTransitQuantityDisplay?: string | null;
    inventoryUOfMDisplay?: string | null;
    pricePerUOFM?: number;
    scheduleUOFM?: string | null;
    baseuofm?: string | null;
    repositoryImageURL?: Array<string> | null;
    readonly pricePerUOFMDisplay?: string | null;
    scheduleUOFMPrice?: number;
    currentCost?: number;
    isRandomWeight?: string | null;
    readonly weightType?: string | null;
    blockEntryBySite?: boolean | null;
    inventoryBySiteCount?: Array<string> | null;
    readonly warningNoInventory?: boolean | null;
}

